export default {
  /**
   * The entityMapping defines a mapping from the resource name to the vuex store in which it should be stored.
   * There is one required key:
   *  - storage   which should be a function which gets the vuex state as parameter and returns the specific object
   *              where it should be stored.
   *              This function gets the _state_ as parameter, so we don't need to have the store as dependency
   * There are also a few optional parameter:
   *  - defaults  an array of potential relations belonging to the object
   *  - idKey  in case a key other than 'id' is used.
   *  for example:
   *  schedules: {
   *    storage: state => state.schedules,
   *    defaults: {
   *      // initialize a few relations so they will be properly reactive later
   *      groups: [],
   *      lecturers: [],
   *      // ...
   *    }
   *  }
   **/
  courses: {
    storage: state => state.courses.courses,
    defaults: {
      events: [],
    },
  },
  events: {
    storage: state => state.events.events,
    defaults: {
      course: null,
      assessmentConfig: null,
      groups: [],
      registrationPossibilities: [],
    },
  },
  download_links: {
    storage: state => state.downloadlinks.download_links,
    defaults: {},
  },
  event_students: {
    storage: state => state.events.event_students,
    defaults: {},
  },
  student_event_contexts: {
    storage: state => state.events.student_event_contexts,
    defaults: {},
  },
  assessment_configs: {
    storage: state => state.events.assessmentConfigs,
    defaults: {
      event: null,
    },
  },
  event_series: {
    storage: state => state.eventseries.eventSeries,
  },
  groups: {
    storage: state => state.groups.groups,
  },
  programs: {
    storage: state => state.programs.programs,
  },
  registration_possibilities: {
    storage: state => state.rps.rps,
  },
  students: {
    storage: state => state.students.students,
  },
  students_courses: {
    storage: state => state.studentscourses.courses,
  },
  terms: {
    storage: state => state.programs.terms,
  },
  users: {
    storage: state => state.users.users,
  },

  student_course_contexts: {
    storage: state => state.subscribables.studentCourseContexts,
    defaults: {
      type: null,
    },
  },

  subscribables: {
    storage: state => state.subscribables.subscribables,
    defaults: {
      eventCluster: null,
      targetGroup: null,
      subscriptions: [],
      subscribableGroupings: [],
      mySubscription: null,
      myQueueSubscription: null,
      events: [],
      course: null,
      myAdvises: [],
      withQueue: false,
      queueStatus: null,
    },
  },
  subscribable_events: {
    storage: state => state.subscribables.events,
    defaults: {
      course: null,
      classrooms: [],
      lecturers: [],
      subscribables: [],
      labels: [],
      groups: [],
    },
  },
  subscribable_courses: {
    storage: state => state.subscribables.courses,
    defaults: {
      labels: [],
    },
  },
  my_subscriptions: {
    storage: state => state.subscribables.mySubscriptions,
  },
  my_queue_subscriptions: {
    storage: state => state.subscribables.myQueueSubscriptions,
  },
  event_clusters: {
    storage: state => state.subscribables.event_clusters,
    defaults: {
      events: [],
    },
  },
  subscribable_groups: {
    storage: state => state.subscribables.groups,
    defaults: {
      labels: [],
    },
  },
  lecturers: {
    storage: state => state.subscribables.lecturers,
    defaults: {
    },
  },
  classrooms: {
    storage: state => state.subscribables.classrooms,
    defaults: {
    },
  },
  subscribable_students: {
    storage: state => state.subscribables.students,
  },
  subscriptions: {
    storage: state => state.subscribables.subscriptions,
    defaults: {
      student: null,
    },
  },
  subscribable_groupings: {
    storage: state => state.subscribables.subscribableGroupings,
  },
  subscribable_config: {
    storage: state => state.subscribables.subscribable_config,
    defaults: {
      type: null,
      enabled: false,
    },
  },
  subscribable_counts: {
    storage: state => state.subscribables.subscribable_counts,
    defaults: {
      type: null,
      count: 0,
    },
  },
  subscribable_statistics: {
    storage: state => state.subscribables.subscribable_statistics,
    defaults: {
      title: null,
      total_single: 0,
      subscribed_single: 0,
      total_appointment: 0,
      subscribed_appointment: 0,
      total_exam: 0,
      subscribed_exam: 0,
    },
  },
  subscribable_grouping_details: {
    storage: state => state.subscribables.subscribableGroupingDetails,
  },
  student_connections: {
    storage: state => state.subscribables.student_connections,
    defaults: {
      id: null,
      subscribable: null,
      time: null,
      action: null,
      done_by: null,
    },
  },
  advises: {
    storage: state => state.advises.advises,
    defaults: {
      messages: [],
    },
  },
  advise_messages: {
    storage: state => state.advises.messages,
  },
  mentors: {
    storage: state => state.advises.mentors,
  },
  question_templates: {
    storage: state => state.subscribables.questionTemplates,
    defaults: {
      answers: [],
      notApplicableAnswers: [],
    },
  },
  label_groups: {
    storage: state => state.subscribables.labelGroups,
    defaults: {
      labels: [],
    },
  },
  labels: {
    storage: state => state.subscribables.labels,
    defaults: {
      label_group: null,
    },
  },
}
